




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Request from "@/modules/request/Request";
import SimpleText from "front-component/components/SimpleText.vue";
import _ from "lodash";

@Component({ components: { SimpleText } })
export default class HierarchyOwner extends Vue {
    @Prop( { default: null }) public request!: Request;

    protected get hierarchyOwner(): string {
        let hierarchyOwnerFullName = _.get(this.request, "hierarchyOwner.fullName", "");
        if (_.get(this.request, "hierarchyOwner.clientCode1", "")) {
            hierarchyOwnerFullName = hierarchyOwnerFullName + " - "
                + _.get(this.request, "hierarchyOwner.clientCode1", "");
        }

        if (_.get(this.request, "hierarchyOwner.address", "") &&
            _.get(this.request, "hierarchyOwner.address.city", "")
        ) {
            hierarchyOwnerFullName = hierarchyOwnerFullName + " ("
                + _.get(this.request, "hierarchyOwner.address.city", "") + ")";
        }

        return hierarchyOwnerFullName;
    }

    public static getNeededFields(): string[] {
        return [
            "request.hierarchyOwner.uuid",
            "request.hierarchyOwner.fullName",
            "request.hierarchyOwner.clientCode1",
            "request.hierarchyOwner.address.city",
            "request.children.hierarchyOwner.fullName",
            "request.children.hierarchyOwner.clientCode1",
            "request.children.hierarchyOwner.address.city"
        ];
    }
}
